import * as React from "react";
import styled from "react-emotion";
import { theme, mqMin } from "../../styles/theme";
import { toHtml } from "../../utilities";
import ScrollNotifier from "../ScrollNotifier";

const Wrap = styled.div`
  max-width: 42rem;
  margin-bottom: ${theme.space3};
  margin-left: auto;
  margin-right: auto;
  text-align: center;
`;

const Caption = styled.figcaption`
  font-size: ${theme.h5};
  font-family: ${theme.sans.fontFamily};
  font-weight: ${theme.sans.normal};
`;

const Image = styled.img`
  width: ${props =>
    props.dimensions.height > props.dimensions.width ? "auto" : "100%"};
  height: ${props =>
    props.dimensions.height > props.dimensions.width ? "80vh" : "auto"};
`;

const ArticleImage = ({ slice }) => {
  console.log(slice);
  return (
    <Wrap>
      <ScrollNotifier onEnter="CLEAR" />
      {slice.items.map((i, k) => (
        <figure>
          <Image k={k} src={i.image.url} dimensions={i.image.dimensions} />
          {i.download_link.url && (
            <Caption>
              <a href={i.download_link.url}>Download Full Resolution</a>
            </Caption>
          )}
        </figure>
      ))}
    </Wrap>
  );
};

export default ArticleImage;



// WEBPACK FOOTER //
// ./src/components/ArticleImage/index.js